var React = require('react');

function SectionBreakBottomMobile (props) {
    return React.createElement("svg",props,React.createElement("clipPath",{"id":"section-break-bottom-mobile","clipPathUnits":"objectBoundingBox"},React.createElement("path",{"d":"M0 0 V1 c 0.2 -0.0125, 0.3 -0.0125, 0.5 -0.00625 s 0.3 0.0125, 0.5 -0.00625 V0 Z"})));
}

SectionBreakBottomMobile.defaultProps = {"width":"0","height":"0","version":"1.1"};

module.exports = SectionBreakBottomMobile;

SectionBreakBottomMobile.default = SectionBreakBottomMobile;
